import './Claimstyle.less';
import { Attachments } from 'types';
import styled from 'styled-components';
import { useEffect, useState } from 'react';
import { Form, Row, Button, Col, Collapse } from 'antd';
import { useTranslation } from 'react-i18next';
import { TIME_TYPE } from '../utils/timeTypes';
// import { POLICY_TYPE } from '../utils/policyTypes';
import { EnquirySuccessPage } from './ClaimSuccessPage';
// import moment from 'moment';
// import { LIFE_ENQUIRY_TYPE } from '../utils/enquiryTypes';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import { useLifeClaimNotification, useGetLifeDoc } from 'all-in-one-shared-api';
import { revalidateAntdFormLanguageChanged } from '../../../i18n';
import { DocumentsCard, Claimform, AgreementCard } from '../components';
import calendar from 'assets/images/MakeClaim/calendar.svg';
import downfile from 'assets/images/MakeClaim/downfile.svg';
import { isLocaleEnglish } from 'utils';
import PdfFileIcon from 'assets/images/PDFfileicon.svg';

// import ChevronRight from 'assets/images/home/chevron-right.svg';

//form定义类型==========================================================================
type ClaimFormInput = {
  name?: string;
  policyNumber?: Array<string>;
  attachments?: Attachments;
  contactTime?: TIME_TYPE;
  causedBy?: string;
  Entermessage?: string;
  deathdob?: string;
  accidentdob?: string;
  detailes?: string;
  Diagnosis?: string;
  countryCode?: string;
  phone?: string;
};
//内容部分布局===========================================================================
const ClaimPageContainer = styled.div`
  margin: 0;
`;
const { Panel } = Collapse;
//=====================================================================================
interface MakeClaimPageProps {
  policyNo?: string;
}

function MakeClaimPage({ policyNo }: MakeClaimPageProps) {
  //定义变量=========================================================
  const { t, i18n } = useTranslation();
  const { token } = useKeycloakReady();
  //定义表单form
  const [form] = Form.useForm<ClaimFormInput>();
  //定义表单上传文件
  const [attachments, setAttachments] = useState<Attachments>();
  //定义绑定�?
  const [isDone, setIsDone] = useState(false);
  // const [isAgreed, setIsAgreed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [enquiryReference, setEnquiryReference] = useState('');
  const [a, seta] = useState('');
  const [documentInvalid, setDocumentInvalid] = useState(false);
  const [isAgreed, setIsAgreed] = useState(false);
  // policyNo is passed as a prop from parent component
  // const GetLifeDocFetchData: ;
  //定义方法=========================================================
  const { shouldFetch: GetLifeDocFetch, data: GetLifeDocFetchData } = useGetLifeDoc('useGetLifeDoc', token || '');
  //提交接口定义
  const {
    shouldFetch: shouldPostEnquirySubmission,
    data: enquirySubmissionData,
    isLoading: enquirySubmissionIsLoading,
    error,
  } = useLifeClaimNotification(
    {
      key: 'useLifeClaimNotification',
      params: { form: form.getFieldsValue() },
    },
    token || '',
    {
      policyHolderName: form.getFieldValue('name'),
      // policyNumber: form.getFieldValue('policyNumber'),
      policyNumber: a,
      claimType: form.getFieldValue('claimType'),
      causedBy: form.getFieldValue('causedBy'),
      accidentDetails: form.getFieldValue('Entermessage'),
      dateOfDeath: form.getFieldValue('deathdob'),
      dateOfAccident: form.getFieldValue('accidentdob'),
      // dateOfDeath: '',
      // dateOfAccident: '',
      details: form.getFieldValue('detailes'),
      diagnosis: form.getFieldValue('Diagnosis'),
      areaCode: form.getFieldValue('countryCode'),
      mobile: form.getFieldValue('phone'),
      contactTime: form.getFieldValue('contactTime'),
      files: attachments?.fileList?.map((a) => a.originFileObj) || [],
      // files: [],
      uploadFlag: false,
    },
  );
  //提交按钮
  const onSubmit = (values: ClaimFormInput) => {
    setSnackbarMessage('');
    setEnquiryReference('');
    console.log('000000');
    const b = form
      .getFieldValue('policyNumber')
      .map((item: string) => item.toString())
      .join(',');
    seta(b);
    // console.log('9999999', form.getFieldValue('policyNumber'));
    console.log('++++++++++', values.attachments);
    console.log('-=====', attachments);
    setAttachments(values.attachments);
    setTimeout(() => shouldPostEnquirySubmission(true), 500);
    setIsLoading(true);
  };
  //监听值useEffect==================================================
  useEffect(() => {
    revalidateAntdFormLanguageChanged(form);
  }, [i18n.language, form]);
  // useEffect(() => {
  //   if (attachments && attachments.fileList.length > 0) {
  //     shouldPostEnquirySubmission(true);
  //   }
  // }, [attachments, shouldPostEnquirySubmission]);
  useEffect(() => {
    if (enquirySubmissionData) {
      console.log('01010110101010', enquirySubmissionData);
      setEnquiryReference(enquirySubmissionData.message);
    }
    if (error) {
      setSnackbarMessage(error.message);
    }
  }, [enquirySubmissionData, error]);
  useEffect(() => {
    if (!snackbarMessage) return;
    shouldPostEnquirySubmission(false);
    setIsLoading(false);
  }, [snackbarMessage, shouldPostEnquirySubmission, isLoading]);
  useEffect(() => {
    if (!enquiryReference) return;
    shouldPostEnquirySubmission(false);
    setIsDone(true);
    setIsLoading(false);
  }, [enquiryReference, setIsDone, setIsLoading, shouldPostEnquirySubmission]);
  useEffect(() => {
    GetLifeDocFetch(true);
  }, [snackbarMessage, GetLifeDocFetch, isLoading]);
  //成功时弹窗页�?======================================================================================
  if (isDone) {
    return <EnquirySuccessPage enquiryReference={enquiryReference} />;
  }
  //页面===============================================================================================
  return (
    <ClaimPageContainer className="Claim">
      <Row justify="center" gutter={[16, { xs: 8, sm: 8, lg: 24 }]} className="ClaimContent">
        <Row>
          <Col xs={24} md={24}>
            {/* <div className="header2">
              <div>{t('life.MakeClaim.makingalife')}</div>
            </div> */}
            <div className="speakheader">
              <div>
                <img src={calendar} style={{ margin: '0  10px 5px 0', width: '24px', height: '24px' }} />
                {t('life.MakeClaim.Speakclaim')}
              </div>
            </div>
          </Col>
        </Row>
        <Col xs={{ span: 24 }} sm={{ span: 20 }} lg={{ span: 24 }}>
          <Row
            justify="center"
            gutter={[16, { xs: 8, sm: 8, lg: 24 }]}
            style={{ background: '#fff' }}
            className="centerlist"
          >
            <Form
              // initialValues={initialValues}
              layout={'vertical'}
              requiredMark={false}
              onFinish={onSubmit}
              form={form}
              validateTrigger={'onSubmit'}
              className="form"
              scrollToFirstError={{ behavior: 'smooth', block: 'center' }}
            >
              <Claimform policyNo={policyNo} />
              <DocumentsCard setInvalid={setDocumentInvalid} />
              <AgreementCard setIsAgreed={setIsAgreed} />
              <Col xs={24} md={24}>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <Button
                    loading={enquirySubmissionIsLoading || isLoading}
                    disabled={documentInvalid || !isAgreed}
                    onClick={() => form.submit()}
                    type="primary"
                    className="subbutton"
                  >
                    {t('life.MakeClaim.SubmitClaimNotification')}
                  </Button>
                </div>
              </Col>
            </Form>
          </Row>
          <Row style={{ marginBottom: '3.7rem' }}>
            <Col xs={24} md={24}>
              <div className="Downloadheader">
                <div>
                  <img src={downfile} style={{ margin: '0  10px 5px 0', width: '24px', height: '24px' }} />
                  {t('life.MakeClaim.DownloadAClaimForm')}
                </div>
              </div>
              <Collapse accordion className="Collapse" expandIconPosition="end">
                <Panel header={t('life.MakeClaim.CriticalIllness')} key="1">
                  {GetLifeDocFetchData?.criticalIllness?.map((item, index) => (
                    <div key={index}>
                      <a
                        key={index}
                        href={isLocaleEnglish(i18n.language) ? item.docUrlEn || '' : item.docUrlTc || ''}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div>
                          <img src={PdfFileIcon} style={{ margin: '0  10px 5px 0', width: '24px', height: '24px' }} />
                          <span>{isLocaleEnglish(i18n.language) ? item.docDescEn || '' : item.docDescTc || ''}</span>
                        </div>
                      </a>
                    </div>
                  ))}
                </Panel>
              </Collapse>
              <Collapse accordion className="Collapse" expandIconPosition="end">
                <Panel header={t('life.MakeClaim.DeathClaim')} key="2">
                  {GetLifeDocFetchData?.deathClaim?.map((item, index) => (
                    <div key={index}>
                      <a
                        key={index}
                        href={isLocaleEnglish(i18n.language) ? item.docUrlEn || '' : item.docUrlTc || ''}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div>
                          <img src={PdfFileIcon} style={{ margin: '0  10px 5px 0', width: '24px', height: '24px' }} />
                          <span>{isLocaleEnglish(i18n.language) ? item.docDescEn || '' : item.docDescTc || ''}</span>
                        </div>
                      </a>
                    </div>
                  ))}
                </Panel>
              </Collapse>
              <Collapse accordion className="Collapse" expandIconPosition="end">
                <Panel header={t('life.MakeClaim.WaiverPremiumClaim')} key="3">
                  {GetLifeDocFetchData?.waiverOfPremium?.map((item, index) => (
                    <div key={index}>
                      <a
                        key={index}
                        href={isLocaleEnglish(i18n.language) ? item.docUrlEn || '' : item.docUrlTc || ''}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <div>
                          <img src={PdfFileIcon} style={{ margin: '0  10px 5px 0', width: '24px', height: '24px' }} />
                          <span>{isLocaleEnglish(i18n.language) ? item.docDescEn || '' : item.docDescTc || ''}</span>
                        </div>
                      </a>
                    </div>
                  ))}
                </Panel>
              </Collapse>
            </Col>
          </Row>
          {/* <Row>
          <Col xs={24} md={24}></Col>
        </Row> */}
        </Col>
      </Row>
    </ClaimPageContainer>
  );
}

export default MakeClaimPage;
